import { Add, Delete, DeleteForever, Edit } from "@mui/icons-material";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputAdornment,
  LinearProgress,
  Typography,
  Grid
} from "@mui/material";
import { PremiumTextField } from "../PremiumInputs";
import { useState } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { addEntry, deleteEntry, editEntry } from "../../firebase/dataHandler";
import * as moment from 'moment'
import DeleteButton from "../deleteButton";

function EditEntryForm({buttonStyle, accountId, refresh, data, entryId}) {
  const [open, setOpen] = useState(false);
  const [isLoading, setLoading] = useState(false);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const validationSchema = yup.object({
    dayCount: yup.number().required().min(1).max(100),
  });

  const formValues = {
    amountPaid: data.amountPaid*data.dayCount,
    date: data.date,
    timeStamp : data.timeStamp,
    dayCount: data.dayCount
  };

  return (
    <>
      <IconButton size="small" style={buttonStyle} onClick={handleClickOpen}>
        <Edit/>
      </IconButton>
      <Dialog 
        open={open} 
        onClose={handleClose}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 16,
            background: 'var(--bg-card)',
            border: '1px solid var(--border-subtle)',
          }
        }}
      >
        <LinearProgress hidden={!isLoading} sx={{ height: 3, '& .MuiLinearProgress-bar': { background: 'linear-gradient(90deg, #15C358, #109441)' } }} />
        <DialogTitle sx={{ pb: 1, borderBottom: '1px solid var(--border-subtle)', mb: 2 }}>
          <Typography sx={{ fontWeight: 800, fontSize: 18, color: 'var(--text-primary)', fontFamily: 'Inter' }}>
            Edit Entry
          </Typography>
          <Typography sx={{ fontSize: 13, color: 'var(--text-muted)', fontFamily: 'Inter' }}>
            Modify collection details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <Formik
            initialValues={formValues}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              setLoading(true)
              editEntry(accountId, entryId, values).then((result)=>{
                actions.setSubmitting(false)
                setLoading(false)
                actions.resetForm()
                refresh && refresh()
                handleClose()
              }).catch(err=>{
                alert(err)
              })
            }}
          >
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <form>
                {Object.keys(formValues).map(val=>errors[val] && touched[val] && <Alert severity="error" sx={{mb: 2}}>{errors[val]}</Alert>)}
                
                <PremiumTextField 
                    id="date"
                    label="Collection Date"
                    type="date"
                    required
                    value={values.date}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputLabelProps={{ shrink: true }}
                />

                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    <PremiumTextField
                      id="dayCount"
                      label="Periods"
                      type="number"
                      required
                      value={values.dayCount}
                      onChange={(e)=>{
                        handleChange(e)
                        values.amountPaid = data.amountPaid * e.target.value
                      }}
                      onBlur={handleBlur}
                      inputProps={{ inputMode: 'numeric', style: { fontSize: 20, textAlign: 'center' } }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <PremiumTextField
                        id="amountPaid"
                        name="amountPaid"
                        type="number"
                        label="Amount Collected"
                        required
                        value={values.amountPaid}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        inputProps={{ inputMode: 'decimal', style: { fontSize: 20, textAlign: 'center', color: '#0A9E5C' } }}
                        InputProps={{
                            startAdornment: <InputAdornment position="start" sx={{'& p':{color:'var(--text-muted)'}}}>₹</InputAdornment>,
                        }}
                    />
                  </Grid>
                </Grid>

                <DeleteButton
                    style={{margin:"5%", marginTop:"30px", width:"90%"}}
                    onPositive={()=>{
                        deleteEntry(accountId, entryId).then(result=>{
                            refresh && refresh()
                            handleClose()
                        }).catch(e=>{
                            alert(e)
                        })
                    }}
                    buttonText="Delete Entry"
                />

                <DialogActions sx={{ pt: 3, px: 0, pb: 0, borderTop: '1px solid var(--border-subtle)', mt: 1 }}>
                    <Button 
                      onClick={handleClose} 
                      sx={{ color: 'var(--text-muted)', fontFamily: 'Inter', fontWeight: 600, px: 3 }}
                    >
                      Cancel
                    </Button>
                    <Button 
                      type="submit" 
                      variant="contained" 
                      onClick={handleSubmit}
                      sx={{ 
                        fontFamily: 'Inter', fontWeight: 700, px: 4, py: 1, borderRadius: 2,
                        background: 'linear-gradient(135deg, #15C358, #109441)',
                        color: '#fff',
                        boxShadow: '0 4px 14px rgba(21, 195, 88, 0.4)',
                        '&:hover': { background: '#109441' }
                      }}
                    >
                      Save Changes
                    </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </DialogContent>
      </Dialog>
    </>
  );
}

export default EditEntryForm;
